import React, { Component } from 'react';


class Cliente extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { cliente, nroDocumento } = this.props;

        return (
            <li id={cliente.Id} className="ul-style-none li-client-search" onClick={() => this.props.seleccionarCliente(cliente)}>
                <div>
                    <div className="client-search-ul">
                        <label className="client-search-label-primary">{`${cliente.Codigo} ${nroDocumento} - ${cliente.Nombre} ${cliente.Apellido}`}</label>
                    </div>
                </div>
            </li>
        );
    }
};
export default Cliente;